import { defineMessages } from "react-intl";

import {
	ab0Messages,
	rhMessages,
	validator
} from "lib/build/forms/htx/bloodGroup";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	bloodGroup: {
		id: "form.blood_group",
		defaultMessage: "Vércsoport"
	},
	ab0: {
		id: "form.blood_group.ab0",
		defaultMessage: "AB0"
	},
	rh: {
		id: "form.blood_group.rh",
		defaultMessage: "RH"
	},
	comment: {
		id: "form.blood_group.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	ab0: {
		type: "field",
		path: ["ab0"],
		label: messages.ab0,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: ab0Messages } }
	},
	rh: {
		type: "field",
		path: ["rh"],
		label: messages.rh,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: rhMessages } }
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.ab0 },
				{ width: 6, field: fields.rh }
			]
		},
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "bloodGroup",
	value: {
		title: messages.bloodGroup,
		validator,
		fieldset,
		isImportant: true
	}
};
